import clsx from "clsx";
import { StatusSignedIcon } from "@/shared/assets/svg/icons";
import "./title-journal-status-badge.scss";

export const TITLE_JOURNAL_STATUS_CONFIG = {
  NEW: { label: "Новый", class: "new" },
  UNDER_APPROVAL: { label: "На согласовании", class: "under-approval" },
  CANCELED: { label: "Отменен", class: "canceled" },
  REJECTED: { label: "Отклонен", class: "rejected" },
  PREPARATION_XML: { label: "Подготовка XML", class: "preparation-xml" },
  DOCUMENT_ERROR: { label: "Ошибка документа", class: "document-error" },
  AT_SIGNING: { label: "На подписании", class: "at-signing" },
  SIGNED: { label: "Подписан", class: "signed", icon: true },
  SENT_TO_GSN: { label: "Отправлено в ГСН", class: "sent-to-gsn" },
  INTERACTION_ERROR_WITH_GSN: {
    label: "Ошибка взаимодействия с ГСН",
    class: "interaction-error-with-gsn",
  },
  COMMENTS_FROM_GSN: { label: "Замечания от ГСН", class: "comments-from-gsn" },
  REGISTERED_WITH_GSN: {
    label: "Зарегистрирован в ГСН",
    class: "registered-with-gsn",
    icon: true,
  },
} as const;

export type TitleJournalStatusKey = keyof typeof TITLE_JOURNAL_STATUS_CONFIG;

interface TitleJournalStatusBadgeProps {
  status: TitleJournalStatusKey | string;
  className?: string;
}

export const TitleJournalStatusBadge = ({
  status,
  className,
}: TitleJournalStatusBadgeProps) => {
  const config =
    TITLE_JOURNAL_STATUS_CONFIG[status as TitleJournalStatusKey] ?? {
      label: String(status),
      class: "new",
    };

  const modifierClass = config.class;
  const { label } = config;
  const showIcon = "icon" in config && config.icon;

  return (
    <span
      className={clsx(
        "title-journal-status-badge",
        `title-journal-status-badge--${modifierClass}`,
        className,
      )}
    >
      {showIcon && (
        <span className="title-journal-status-badge__icon">
          <StatusSignedIcon />
        </span>
      )}
      <span className="title-journal-status-badge__label">{label}</span>
    </span>
  );
};
